import * as THREE from 'three'
import defaults from 'lodash/defaults'

function GL(el, scene, renderer, camera) {
    this.el = el
    this.scene = scene
    this.renderer = renderer
    this.camera = camera
}

GL.prototype.add = function (obj, parent, opts) {
    opts = defaults(opts || {}, {
        name: null,
    })

    if (!parent) {
        parent = this.scene
    }

    parent.add(obj)
    if (name) {
        obj.name = name
    }

    return this
}

GL.prototype.resize = function () {
    const { offsetWidth } = this.el
    const offsetHeight = 706.5 // this.el.offsetHeight;

    this.camera.aspect = offsetWidth / offsetHeight

    // for orthographic camera
    this.camera.left = offsetWidth / -2
    this.camera.right = offsetWidth / 2
    this.camera.top = offsetHeight / 2
    this.camera.bottom = offsetHeight / -2

    this.camera.updateProjectionMatrix()

    this.renderer.setSize(offsetWidth, offsetHeight, false)

    return this.tick()
}

GL.prototype.tick = function () {
    this.scene.updateMatrixWorld()
    this.renderer.render(this.scene, this.camera)

    return this
}

function clearMesh(scene, mesh) {
    // TODOHI	need to avoid disposing shared geometries?
    const geom = mesh.geometry
    // mat = mesh.material;

    // scene.remove(mesh);
    // if (geom) {
    //	//geom.dispose();
    // } else {
    //	each(mesh.children, function (obj) {
    //		// TODO need to handle if obj is not a Mesh?
    //		clearMesh(obj);
    //	})
    // }

    scene.remove(mesh)
    if (geom) {
        geom.dispose()
    }
    // each(mesh.children, function (obj) {
    //     // TODO need to handle if obj is not a Mesh?
    //     clearMesh(scene, obj);
    // });
    mesh.children.forEach((obj) => {
        // TODO need to handle if obj is not a Mesh?
        clearMesh(scene, obj)
    })
    // if (mat) {
    //	mat.dispose();
    // }
    // mesh.dispose();	// only in ThreeJS dev version so far?
}

GL.prototype.clearMesh = function (mesh) {
    clearMesh(this.scene, mesh)
}

GL.withPerspectiveCamera = function (el, opts) {
    opts = defaults(opts || {}, {
        camera: {
            up: new THREE.Vector3(0, 0, 1),
            pos: new THREE.Vector3(500, 500, 200),
            lookAt: new THREE.Vector3(0, 0, 0),
        },
        antialias: true,
        alpha: true,
    })

    const { offsetWidth } = el
    const { offsetHeight } = el
    const aspectRatio = offsetWidth / offsetHeight
    const dpr = window.devicePixelRatio || 1

    const scene = new THREE.Scene()
    // scene.background = new THREE.Color(0x34a0e1)
    const camera = new THREE.PerspectiveCamera(50, aspectRatio, 1, 5000)
    camera.aspect = aspectRatio
    camera.position.copy(opts.camera.pos)
    camera.up.copy(opts.camera.up)
    camera.lookAt(opts.camera.lookAt)
    camera.updateProjectionMatrix()

    const renderer = new THREE.WebGLRenderer({
        canvas: el,
        antialias: opts.antialias,
        alpha: opts.alpha,
        logarithmicDepthBuffer: true,
    })

    renderer.setPixelRatio(dpr)
    renderer.setSize(offsetWidth, offsetHeight, false)

    return new GL(el, scene, renderer, camera, opts)
}

GL.withOrthographicCamera = function (el, opts) {
    // ? underscore does not have defaults deep
    opts = defaults(opts || {}, {
        camera: {
            up: new THREE.Vector3(0, 0, 1),
            pos: new THREE.Vector3(100, 100, 100),
            lookAt: new THREE.Vector3(0, 0, 0),
        },
        antialias: true,
        alpha: true,
    })

    const { offsetWidth } = el
    const { offsetHeight } = el
    const dpr = window.devicePixelRatio || 1

    const scene = new THREE.Scene()

    const renderer = new THREE.WebGLRenderer({
        canvas: el,
        antialias: opts.antialias,
        alpha: opts.alpha,
    })

    renderer.setPixelRatio(dpr)
    renderer.setSize(offsetWidth, offsetHeight, false)

    const camera = new THREE.OrthographicCamera(
        offsetWidth / -2,
        offsetWidth / 2,
        offsetHeight / 2,
        offsetHeight / -2,
        -1000,
        1000
    )

    camera.position.copy(opts.camera.pos)
    camera.up.copy(opts.camera.up)
    camera.lookAt(opts.camera.lookAt)
    camera.zoom = 1

    camera.updateProjectionMatrix()

    scene.add(camera)

    return new GL(el, scene, renderer, camera, opts)
}

export default GL
